<template>
  <div class="userAccountWrap mb20 bgWhite">
    <div class="tagWrap">
      <span class="tag" v-for="(item, index) in tagList" :class="{ active: tagActive == index }"
        @click="changeTag(index)">{{ item }}</span>
    </div>
    <div class="userAccount">
      <div v-if="tagActive == 0" class="walletWrap">
        <div class="balanceWrap">
          <div class="balance" :style="{ backgroundImage: 'url(' + walletBg1 + ')' }">
            <span class="tit">金龙元宝余额：</span>
            <span class="num" v-if="userInfo.wallteInfos">{{ userInfo.wallteInfos[0].balance ?
              userInfo.wallteInfos[0].balance : 0 }}</span>
            <span class="recharge" @click="goRecharge"></span>
          </div>
        </div>
        <div class="bindBalanceWrap">
          <div class="bindBalance" :style="{ backgroundImage: 'url(' + walletBg2 + ')' }">
            <span class="tit">银龙元宝余额：</span>
            <span class="num" v-if="userInfo.wallteInfos">{{ userInfo.wallteInfos[1].balance }}</span>
          </div>
        </div>
        <div class="divideWrap">
          <div class="divide">
            <el-form ref="form" :model="divideForm" label-width="100px">
              <el-form-item label="划分大区:">
                <el-select v-model="divideForm.serverId" placeholder="请选择大区">
                  <el-option :label="item.serverName" :value="item.serverId" v-for="item in serverList"
                    :key="item.serverId" />
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="划分金额:">
                <el-input v-model="divideForm.money" placeholder="请输入银龙元宝数量"></el-input>
                <div class="tip moneyTip">划分比例：1:100</div>
              </el-form-item>
              <el-form-item class="submitWrap">
                <el-button class="btn" type="primary" @click="divideFormSubmit">划分</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div v-else-if="tagActive == 1" class="vipWrap">
        <div class="userInfo">
          <div class="item item1">
            <img :src="vipIcon1" alt="">
            <div class="txt">
              <span class="tit">我的积分:</span>
              <span class="num">{{ vipInfo.points }}</span>
              <span class="total">（累计：{{ vipInfo.sumPoints }}）</span>
            </div>
          </div>
          <div class="item item1">
            <img :src="vipIcon2" alt="">
            <div class="txt">
              <span class="tit">VIP等级:</span>
              <span class="num">{{ vipInfo.viplevel }}</span>
            </div>
          </div>
        </div>
        <div class="btnWrap">
          <img style="cursor: pointer" :src="vipIcon3" alt="" @click="vipMask">
          <img style="cursor: pointer" :src="vipIcon4" @click="goShop" alt="">
          <img style="cursor: pointer" :src="vipIcon5" @click="goRecharge" alt="">
        </div>
        <div class="integralWrap">
          <div class="item" v-for="(item, index) in vipInfo.vipconfigList" :key="item.levelId">
            <el-tooltip :content="item.levelId == 10 ? ' 幸运钥匙*1000，至尊骑宠礼盒*1，VIP黄金礼包*1，36星经典技能卡礼包*4' : item.prizeText"
              placement="bottom" effect="light">
              <img class="grade" :src="item.imgUrl" alt="">
            </el-tooltip>

            <span class="fen">{{ item.title }}</span>
            <img v-if="item.isClick && item.btnText == '领取'" class="btn" :src="vipIcon6" alt="" @click="receive(item)">
            <img v-else-if="item.isClick == false && item.btnText == '领取'" class="btn" :src="vipIcon8">
            <img v-else class="btn" :src="vipIcon7" alt="">
          </div>
        </div>
        <div class="ruleWrap">
          <div class="tit">VIP规则说明</div>
          <div class="cons">
            <p class="txt1"><span
                class="num">1.</span><span>用户充值后可获得VIP积分，依据累计获取的积分提升VIP等级，目前最高等级为VIP10。（1RMB附赠1积分）。</span></p>
            <p class="txt1"><span class="num">2.</span><span>用户达到相应VIP等级后可领取对应等级VIP福利.</span></p>
            <p class="txt1"><span class="num">3.</span><span>VIP福利可累计获取但每种仅限一次。</span></p>
            <p class="txt1"><span
                class="num">4.</span><span>幸运钥匙以及相关道具奖励请至网站商城个人仓库中查看。（领取成功后30分钟内到账）。</span>
            </p>
            <p class="txt1"><span class="num">5.</span><span>用户达到VIP10以后依然可以正常获取积分。</span></p>
            <p class="txt1"><span class="num">6.</span><span>VIP4及以上玩家每个月10日将会获得一份回馈奖励：</span></p>
            <p class="txt1"><span class="num"></span><span style="color: #6c3f00;font-weight: 700;">1.可丽露碎片X1</span></p>
            <p class="txt1"><span class="num"></span><span style="color: #6c3f00;font-weight: 700;">2.马戏团浏览券x88</span></p>
            <p class="txt1"><span class="num"></span><span style="color: #6c3f00;font-weight: 700;">3.火舞玫瑰种子X88</span></p>
            <p class="txt1"><span class="num"></span><span style="color: #6c3f00;font-weight: 700;">4.黄金马赛克地砖X2</span></p>
            <p class="txt1"><span class="num"></span><span style="color: #6c3f00;font-weight: 700;">5.六倍经验果（1小时）X2</span></p>
          </div>
        </div>
      </div>

    </div>
    <pubMask v-if="isShowPask" :isShowPask="isShowPask" :propShowSwitch="showSwitch" :title="maskTitle"
      :tipCon="tipCon"></pubMask>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import eventBus from '@/common/bus.js'
import pubMask from '@/components/pubMask'
import { publicUrl } from '@/common/publicUrl.js'
import { getServerList, getMemberInfoApi } from '@/api/public.js'
import { getVipInfoApi, getToDivideApi, getVipPrizeApi } from '@/api/component/userInfo.js' // 获取VIP信息   钱包划分
// 自定义弹窗
// import Messages  from "@/common/Message/index.js";

export default {
  name: "index",
  components: {
    pubMask
  },
  props: {
    serverId: {
      type: Number,
    }
  },
  data() {
    return {
      serverList: [],
      walletBg1: require('@/assets/imgs/account/walletBg1.png'),
      walletBg2: require('@/assets/imgs/account/walletBg2.png'),
      vipIcon1: require('@/assets/imgs/account/vipIcon1.png'),
      vipIcon2: require('@/assets/imgs/account/vipIcon2.png'),
      vipIcon3: require('@/assets/imgs/account/vipIcon3.png'),
      vipIcon4: require('@/assets/imgs/account/vipIcon4.png'),
      vipIcon5: require('@/assets/imgs/account/vipIcon5.png'),
      vipIcon6: require('@/assets/imgs/account/vipIcon6.png'),
      vipIcon7: require('@/assets/imgs/account/vipIcon7.png'),
      vipIcon8: require('@/assets/imgs/account/vipIcon8.png'),
      tagActive: this.$route.query.type ? this.$route.query.type : 0,
      tagList: ['我的钱包', 'VIP会员'],
      userInfo: {
        verifyInfo: {},
        vipInfo: {},
        wallteInfos: [],
        gameDataInfo: {
          onlineTime: 0,
          coupleExp: 0,
          sisterExp: 0,
          roleLevel: 1,
          lastUpdateDate: '', //上次保存时间
        }
      },
      isShowPask: false,
      showSwitch: 4,
      maskTitle: 'VIP福利',

      divideForm: {        // 划分
        serverId: '',
        money: '',
      },
      vipInfo: {
        points: '',
        sumPoints: '',
        viplevel: '',
        vipconfigList: [],
      },
      bubbleValue: '',
      bubbleList: [],
      tipCon: '',
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    eventBus.$on('closeMask', this.closeMask)
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));

  },
  mounted() {
    let _this = this
    this.init()
    window.addEventListener('setItem', () => {
      _this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    });

    if (this.tagActive == 0) {

    } else if (this.tagActive == 1) {
      this.getVipList()
    } else if (this.tagActive == 2) {
      // 获取泡点列表
    }

  },
  methods: {

    async receive(item) {
      await getVipPrizeApi({
        levelId: item.levelId,
        userId: Cookies.get('cwsl_userId'),      // userId
        serverId: 1,
        platForm: 'web',
      }).then((res) => {
        if (res.data.state == 200) {
          this.$message.success(res.data.message)
          this.getMemberInfo()
          this.getVipList()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },              // 领取VIP会员积分
    goShop() {
      window.open(publicUrl.shopIntegralUrl, '_blank')
    },
    goRecharge() {
      this.$router.push('/recharge')
    },                // 去充值页面
    goRecord() {
      this.$router.push('/record?type=4')
    },               // 进入充值记录


    async getMemberInfo() {

      await getMemberInfoApi({
        userId: Cookies.get('cwsl_userId'),      // userId
        platForm: 'web',
      }).then((res) => {
        if (res.data.state == 200) {
          this.userInfo = res.data.data
          this.resetSetItem('userInfo', JSON.stringify(res.data.data))
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },          // 获取用户信息
    divideFormSubmit() {
      var reg = /^[1-9][0-9]*$/;
      if (this.divideForm.serverId == '') {
        this.$message.error('请选择大区')
      } else if (this.divideForm.money == '') {
        this.$message.error('请输入划分金额')
      } else if (this.divideForm.money == 0) {
        this.$message.error('输入大于0的，不能输入负数')
      } else if (isNaN(this.divideForm.money)) {
        this.$message.error('划分金额只能是纯数字')
      } else if (Number(this.divideForm.money) <= 0) {
        this.$message.error('划分金额不能小于0')
      } else if (!(reg.test(this.divideForm.money))) {
        this.$message.error('请输入大于等于1的整数')
      } else if (Number(this.divideForm.money) > 10000) {
        this.$message.error('单笔划分金额最高为10000银龙元宝')
      } else {
        const serveritem = this.serverList.find(item => item.serverId === this.divideForm.serverId);
        this.$confirm(`<div>
          您确定划分<span style='color:red'>${this.divideForm.money}银龙元宝</span>至<sapn style='color:red'>${serveritem.serverName}</sapn>吗
          </div>`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(async () => {

          await getToDivideApi({
            coins: this.divideForm.money,
            platForm: 'web',
            userId: Cookies.get('cwsl_userId'),      // userId
            serverId: this.divideForm.serverId
          })
            .then((res) => {
              if (res.data.state == 200) {
                let _this = this
                this.$message.success(res.data.message)
                this.divideForm.money = ''
                this.getMemberInfo()
              } else {
                this.$message.error(res.data.message)
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      }
    },       // 划分
    changeTag(index) {
      this.tagActive = index;
      if (index == 0) {

      } else if (index == 1) {
        this.getVipList()
      } else {
        this.getBubbleList()        // 获取泡点列表
      }
    },   // 切换我的钱包，vip，泡点
    async getVipList() {

      await getVipInfoApi({
        userId: Cookies.get('cwsl_userId'),      // userId
        serverId: this.serverId,
        platForm: 'web',
      }).then((res) => {
        if (res.data.state == 200) {
          this.vipInfo = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },       // 获取VIPlist
    vipMask() {
      this.isShowPask = true;
      this.showSwitch = 4
      this.maskTitle = 'VIP福利'
    },          // VIP福利弹窗
    closeMask() {
      this.isShowPask = false
    },
    async init() {
      await getServerList({})
        .then(({ data }) => {
          if (data.state == 200) {
            this.serverList = data.data.list
          }
        })
    }
  },
}
</script>

<style scoped lang="less">
.userAccountWrap {
  padding: 30px 30px 20px;
  box-shadow: 0px 2px 8px 0px #EED9FF, 0px 0px 4px 0px rgba(255, 255, 255, 0.25);

  .tagWrap {
    display: flex;
    margin-bottom: 10px;
    border-bottom: 1px solid #333333;

    .tag {
      margin-right: 100px;
      padding: 8px 0;
      font-size: 20px;
      cursor: pointer;
      border-bottom: 4px solid #ffffff;
    }

    .active {
      font-size: 26px;
      border-bottom: 4px solid #734E00;
    }
  }

  .walletWrap {
    display: flex;
    justify-content: space-between;

    .balanceWrap,
    .bindBalanceWrap {
      padding-top: 10px;
    }

    .balance,
    .bindBalance {
      padding: 30px 15px;
      background-repeat: no-repeat;
      height: 128px;
      box-sizing: border-box;
      color: #ffffff;

      .tit {
        margin-bottom: 20px;
        font-size: 16px;
      }

      .num {
        display: block;
        margin-top: 20px;
        font-size: 30px;
      }
    }

    .balance {
      position: relative;
      z-index: 1;
      padding-right: 30px;
      width: 236px;
      min-width: 236px;

      .recharge {
        position: absolute;
        right: 1px;
        bottom: 6px;
        z-index: 2;
        display: inline-block;
        width: 30px;
        height: 90px;
        text-align: center;
        cursor: pointer;
      }
    }

    .bindBalance {
      width: 212px;
      min-width: 212px;
    }

    .divide {
      margin-right: 50px;
      width: 320px;
      min-width: 320px;

      .tip {
        color: #FF0000;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
      }
    }
  }

  .vipWrap {
    padding-top: 10px;

    .userInfo {
      margin-bottom: 25px;
      display: flex;
      justify-content: space-between;

      .item {
        display: flex;
        align-items: center;

        .txt {
          span {
            display: inline-block;
            font-size: 18px;
          }
        }

        .num {
          margin-left: 5px;
          padding: 5px 0;
          width: 220px;
          min-width: 220px;
          border-bottom: 1px dashed #333333;
        }
      }
    }

    .btnWrap {
      margin-bottom: 20px;

      img {
        margin-right: 40px;
      }
    }

    .integralWrap {
      overflow: hidden;
      margin-right: -30px;

      .item {
        margin-right: 30px;
        margin-bottom: 30px;
        float: left;
        width: 150px;
        text-align: center;

        span {
          display: block;
          font-size: 20px;
        }

        .grade {
          height: 80px;
          line-height: 80px;
          font-weight: 700;
          background: rgba(210, 33, 144, 0.1);
          border-radius: 4px 4px 4px 4px;
        }

        .fen {
          height: 38px;
          line-height: 38px;
        }

        .btn {
          cursor: pointer;
        }
      }
    }

    .ruleWrap {
      .tit {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      .cons {
        padding: 30px 20px 30px 30px;
        min-height: 200px;
        line-height: 24px;
        background: rgba(210, 33, 144, 0.1);
        border-radius: 10px 10px 10px 10px;

        p {
          margin-bottom: 10px;
        }

        .txt1 {
          margin-top: 15px;
          display: flex;

          span {
            font-size: 16px;
          }

          .num {
            min-width: 20px;
          }
        }
      }
    }
  }

  .bubbleWrap {
    padding-top: 10px;

    .userInfo {
      padding-bottom: 30px;
      overflow: hidden;

      .item {
        margin-bottom: 10px;
        float: left;
        width: 50%;
        height: 34px;

        span {
          display: inline-block;
        }

        img {
          transform: translateY(5px);
          cursor: pointer;
        }

        .tit {
          margin-right: 5px;
          width: 135px;
          text-align: right;
          font-size: 18px;
        }

        .txt {
          padding: 5px 0;
          width: 210px;
          font-size: 18px;
          border-bottom: 1px dashed #333333;
        }

        .exchange {
          margin-left: 5px;
          width: 90px;
          height: 30px;
          line-height: 30px;
          color: #ffffff;
          text-align: center;
          background: #734E00;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }

    .bubbleInfo {
      .des {
        padding: 40px;
        background: rgba(210, 33, 144, 0.1);
        border-radius: 10px 10px 10px 10px;

        .tit {
          margin-bottom: 20px;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          -webkit-text-stroke: 1px #bc49de;
          /* Safari */
          text-stroke: 1px #bc49de;
          letter-spacing: 3px;
          text-align: center;
        }

        p {
          margin-bottom: 15px;
          font-size: 16px;
          color: #bc49de;
        }
      }

      .cons {
        border-left: 1px solid #734E00;
        border-top: 1px solid #734E00;
        overflow: hidden;

        .item {
          float: left;
          padding-left: 60px;
          width: 50%;
          height: 100px;
          line-height: 100px;
          border-right: 1px solid #734E00;
          border-bottom: 1px solid #734E00;
          box-sizing: border-box;
        }
      }
    }

    .confirmWrap {
      text-align: center;

      span {
        display: inline-block;
        width: 150px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        color: #ffffff;
        background: #734E00;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
}
</style>
